import React from 'react';
import PropTypes from 'prop-types';
import { find, get } from 'lodash';
import {
  VAN_WESTENDORP_QUESTION_DECIMALS,
  VAN_WESTENDORP_QUESTION_MAX_PRICE,
  VAN_WESTENDORP_QUESTION_MIN_PRICE,
} from './constants';
import useSetup from './hooks/useSetup';
import MatrixVanWestendorpAnswer from './MatrixVanWestendorpAnswer';

export default function MatrixVanWestendorp({ question }) {
  const options = get(
    question,
    'matrix.validation.vanWestendorpValidation',
    {},
  );
  const {
    min = VAN_WESTENDORP_QUESTION_MIN_PRICE,
    max = VAN_WESTENDORP_QUESTION_MAX_PRICE,
    decimals = VAN_WESTENDORP_QUESTION_DECIMALS,
  } = options;

  const answerColumnValueTypes = get(
    question,
    'matrix.answerColumnValueTypes',
    [],
  );

  const columns = get(question, 'matrix.columns', []);

  // use answer array to keep the given order
  const answers = question.answers.map((answer) => {
    const answerColumnValueType = find(answerColumnValueTypes, [
      'answerId',
      answer.id,
    ]);
    const column = find(columns, ['id', answerColumnValueType.columnId]);
    return {
      ...answer,
      type: answerColumnValueType.type,
      columnOrder: column.order,
      columnId: column.id,
    };
  });

  useSetup({ decimals });

  return (
    <div className="matrix-wrapper">
      {answers.map((answer) => (
        <div
          key={answer.id}
          className="matrix clearfix answerMatrixVanWestendorp"
          data-answer-id={answer.id}
          data-answer-column-id={answer.columnId}
          data-answer-column-order={answer.columnOrder}
        >
          <div className="matrix__question" data-testid="matrix-row">
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: answer.body || '&nbsp;' }}
            ></span>
            <div className="matrix__labels">
              <span
                className="matrix__selected-answer"
                data-answer-id={answer.id}
              ></span>
            </div>
          </div>
          <div className="matrix__answers" data-answer-id={answer.id}>
            <MatrixVanWestendorpAnswer answer={answer} min={min} max={max} />
          </div>
        </div>
      ))}
    </div>
  );
}

MatrixVanWestendorp.propTypes = {
  question: PropTypes.object,
};
